import { render, staticRenderFns } from "./coachBond.vue?vue&type=template&id=3d181312&"
import script from "./coachBond.vue?vue&type=script&lang=js&"
export * from "./coachBond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports